module.exports = __webpack_public_path__ + "img/subtitles.4e5af2a5.svg";